import { Typography } from '@/shared/ui/Typography/Typography';
import * as React from 'react';

import OkIcon from '@/assets/icons/complated.svg?react';
import CloseIcon from '@/assets/icons/close.svg?react';
import { IconButton } from '@/shared/ui/Button/IconButton';


export interface IFeedbackSuccessCardProps {
    handleClose: () => void
}

export function FeedbackSuccessCard({handleClose}: IFeedbackSuccessCardProps) {

    return (
        <div className='absolute w-full h-full bg-black/70 left-0 top-0 flex justify-center items-center'>

            <div className='w-[300px] h-[230px] rounded-2xl bg-white p-5 lg:p-5 lg:w-[460px] lg:h-[300px] flex flex-col justify-center items-center gap-4 relative'>

                <OkIcon />

                <Typography className='lg:text-[1.2rem] text-center lg:font-semibold'>
                    Спасибо! Наш менеджер скоро свяжется с вами!
                </Typography>

                <IconButton
                    className='border absolute right-4 top-4'
                    icon={<CloseIcon/>}
                    onClick={handleClose}
                />
            </div>

        </div>
    );
}
